const CARD_CODE = /^[A-Za-z0-9_-]{22}$/;

/** Till origin from `VITE_CARD_PREVIEW_BASE` (no trailing slash). */
export function cardPreviewBase(): string {
	return `${import.meta.env.VITE_CARD_PREVIEW_BASE || ""}`.replace(/\/$/, "");
}

/** Prefer the local till (`VITE_CARD_PREVIEW_BASE`) so the iframe is not blocked. */
export function cardPreviewUrl(cardId: string, cardUrl: string): string {
	const base = cardPreviewBase();
	if (base && CARD_CODE.test(cardId)) {
		return `${base}/${cardId}`;
	}
	return cardUrl;
}

export function openCardPreviewWindow(url: string): boolean {
	if (!url) {
		return false;
	}
	const popup = window.open(
		url,
		"play-till-card",
		"popup=yes,width=430,height=844,resizable=yes,scrollbars=yes",
	);
	if (!popup) {
		window.open(url, "_blank", "noopener,noreferrer");
		return false;
	}
	popup.opener = null;
	return true;
}

export function resolvePreviewSrc(raw: string, fallbackUrl: string): string {
	const value = raw.trim();
	if (!value) {
		return fallbackUrl;
	}
	if (CARD_CODE.test(value)) {
		return cardPreviewUrl(value, fallbackUrl);
	}
	return value;
}
